import { Box, media, styled } from '@migros/msrc-ui-kit';
import { ARTICLE_TEXT_HEIGHT_RATING, MINI_TILE_CONTENT_HEIGHT, MINI_TILE_CONTENT_HEIGHT_TABLET } from '../../../helpers';
export const ArticleMiniContainer = styled(Box)`
  height: ${({
  hideRating
}) => hideRating ? MINI_TILE_CONTENT_HEIGHT : ARTICLE_TEXT_HEIGHT_RATING + MINI_TILE_CONTENT_HEIGHT}px;

  ${({
  hideRating
}) => media.tabletAndUp`
    height: ${hideRating ? MINI_TILE_CONTENT_HEIGHT_TABLET : ARTICLE_TEXT_HEIGHT_RATING + MINI_TILE_CONTENT_HEIGHT_TABLET}px;
  `}
`;